
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/changelog/[[...slug]]",
      function () {
        return require("private-next-pages/changelog/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/changelog/[[...slug]]"])
      });
    }
  